import React from 'react';

import { ReactComponent as MagnifierIcon } from 'svg/magnifier.svg';

import { createSearchInputLayoutClassName } from './searchInputLayoutStyles';

type Props = {
  control: React.ReactNode;
};

export const SearchInputLayoutComponent: React.FC<Props> = (props) => {
  const { control } = props;

  const wrapperClassName = createSearchInputLayoutClassName('wrapper');

  const iconSlotClassName = createSearchInputLayoutClassName('iconSlot');

  const controlSlotClassName = createSearchInputLayoutClassName('controlSlot');

  return (
    <label className={wrapperClassName}>
      <div className={iconSlotClassName}>
        <MagnifierIcon />
      </div>
      <div className={controlSlotClassName}>{control}</div>
    </label>
  );
};
